import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import { useState, useEffect, useRef } from "preact/hooks"
import DesktopFacet from "./DesktopFacet"

export default function DesktopFilters() {
    const { loading, facets } = useFacets()
    const [openFacetId, setOpenFacetId] = useState(null)
    const containerRef = useRef(null)

    // Handle clicks outside the active facet to close the dropdown
    useEffect(() => {
        if (!openFacetId) return

        const handleClickOutside = (event) => {
            const container = containerRef.current

            if (!container) return

            const target = event.target

            if (!container.contains(target)) {
                setOpenFacetId(null)
                return
            }

            if (!(target instanceof Element)) return

            const facetElement = target.closest('.ns-desktop-filter-single')

            if (!facetElement || facetElement.dataset.facetId !== openFacetId) {
                setOpenFacetId(null)
            }
        }

        document.addEventListener('click', handleClickOutside)
        return () => document.removeEventListener('click', handleClickOutside)
    }, [openFacetId])

    const handleFacetToggle = (facetId, isOpen) => {
        setOpenFacetId(isOpen ? facetId : null)
    }

    // Only show if we have facets
    if (!facets || facets.length === 0) {
        return null
    }

    return (
        <div 
            ref={containerRef}
            class="ns-desktop-filters ns-d-none ns-d-md-flex"
            style={loading ? "opacity: 0.3;" : ""}
        >
            {facets.map(facet => {
                switch (facet.type) {
                    case "terms":
                        return (
                            <DesktopFacet 
                                key={facet.id} 
                                facet={facet}
                                isOpen={openFacetId === facet.id}
                                onToggle={handleFacetToggle}
                            />
                        )
                    case "stats":
                        // For now, skip range facets in desktop view - can be added later if needed
                        return null
                    default:
                        return null
                }
            })}
        </div>
    )
}
